/**
 * Portfolio — single page.
 * Theme toggle (persisted under localStorage "darkMode", class .dark-mode on <html>),
 * and a scroll-spy that marks the current section in the nav.
 * Dark is the default; the inline script in <head> applies the stored choice before first paint.
 */

const html = document.documentElement;
const STORAGE_KEY = "darkMode";

function setTheme(dark) {
  html.classList.toggle("dark-mode", dark);
  try { localStorage.setItem(STORAGE_KEY, dark ? "enabled" : "disabled"); } catch {}
  const toggle = document.getElementById("darkModeToggle");
  if (toggle) toggle.setAttribute("aria-pressed", String(dark));
}

function initThemeToggle() {
  const toggle = document.getElementById("darkModeToggle");
  if (!toggle) return;
  toggle.setAttribute("aria-pressed", String(html.classList.contains("dark-mode")));
  toggle.addEventListener("click", () => setTheme(!html.classList.contains("dark-mode")));

}

function initScrollSpy() {
  const links = [...document.querySelectorAll('.site-nav__links a[href^="#"]')];
  const sections = links
    .map((a) => document.querySelector(a.getAttribute("href")))
    .filter(Boolean);
  if (!sections.length || !("IntersectionObserver" in window)) return;

  const setCurrent = (id) => {
    links.forEach((a) => {
      const on = a.getAttribute("href") === `#${id}`;
      if (on) a.setAttribute("aria-current", "true");
      else a.removeAttribute("aria-current");
    });
  };

  const visible = new Map();
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => visible.set(e.target.id, e.isIntersecting ? e.intersectionRatio : 0));
      let best = null, bestRatio = 0;
      for (const [id, ratio] of visible) if (ratio > bestRatio) { best = id; bestRatio = ratio; }
      if (best) setCurrent(best);
      else if (window.scrollY < 200) links.forEach((a) => a.removeAttribute("aria-current"));
    },
    { rootMargin: "-40% 0px -45% 0px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
  );
  sections.forEach((s) => observer.observe(s));
}

initThemeToggle();
initScrollSpy();
